import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 300;
  background-color: rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled.div`
  min-width: 400px;
  padding: 36px 30px;
  border-radius: 8px;
  background-color: white;
`;

const ModalTitle = styled.div`
  font-size: 18px;
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid #a6b0cf;
`;

const ModalContent = styled.div``;

const Modal = ({ isVisible, title = 'Title', children }) => {
  if (!isVisible) return null;

  return (
    <Overlay>
      <ModalContainer>
        <ModalTitle>{title}</ModalTitle>
        <ModalContent>{children}</ModalContent>
      </ModalContainer>
    </Overlay>
  );
};

export default Modal;
